"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.clientContainer = void 0;
exports.default = authenticate;
var _urlSearchParams = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/url-search-params"));
var _codeFlowClient = _interopRequireDefault(require("./codeFlowClient"));
var _tmcClient = _interopRequireDefault(require("./tmcClient"));
const clientContainer = exports.clientContainer = {}; // way to shared late-bound client

const codeFlowClient = new _codeFlowClient.default();
const tmcClient = new _tmcClient.default();
const idpHintQPKeys = ['kc_idp_hint', 'idp_hint'];
const idpConfigKeys = ['keycloakIdpHint', 'idpHint'];
function getIdpHint(config) {
  const searchParams = new _urlSearchParams.default(window.location.search.substring(1));

  // Query param trumps domain configuration
  for (let key of idpHintQPKeys) {
    if (searchParams.has(key)) {
      const idpHint = searchParams.get(key);
      if (idpHint) {
        return idpHint === '' ? false : idpHint; //param without a value
      }
    }
  }

  for (let key of idpConfigKeys) {
    if (config[key]) {
      return config[key];
    }
  }
}
async function registerTmcAuthRefresh(client, TMC, accountId) {
  const tmcConfig = await TMC.auth(client.accessToken);
  tmcConfig.accountId = accountId;
  const {
    transporter
  } = tmcConfig;
  client.registerAuthRefresh(({
    accessToken
  }) => transporter.token = accessToken);
  return transporter;
}
async function registerSharedAuthRefresh(client, shared) {
  shared.accessToken = client.accessToken;
  client.registerAuthRefresh(({
    accessToken
  }) => shared.accessToken = accessToken);
}
async function authenticate({
  TMC,
  config,
  shared,
  accountId
}) {
  // if using a confidential/secret client authenticate with the SDK TMC else
  // use the code flow client

  let client, transporter;
  if (config.clientSecret || config.token) {
    client = tmcClient;
    client.init({
      ...config,
      TMC,
      accountId
    });
    await client.logIn();
    transporter = client.transporter;
  } else {
    client = codeFlowClient;

    // TODO: determine if this should be supplied by the calling app
    const idpHint = getIdpHint(config);
    if (!idpHint) {
      console.warn('missing IDP hint'); // eslint-disable-line no-console
    }

    client.init({
      ...config,
      idpHint
    });
    await client.logIn();
    if (TMC) {
      // TODO: remove condition if TMC is always present
      transporter = await registerTmcAuthRefresh(client, TMC, accountId);
    }
  }

  // if accountId is not specified assume token's value
  accountId = accountId || client.accountId;

  // initialize global auth and keep up-to-date
  if (shared) {
    registerSharedAuthRefresh(client, shared);
    if (transporter) {
      shared.base = transporter.base;
      shared.transporter = transporter;
    }
    shared.accountId = accountId;
    shared.email = client.email;
  }
  clientContainer.client = client;
  return client;
}